// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","border":"Header_border__dM0mJ","titleTooltip":"Header_titleTooltip__tXJjf"};